export default {"src":"/_next/static/media/tv.0f2643d3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};